import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

/**
 * Shared client dropdown for scoped pages (Phase 7.2).
 * Controlled: value = client id; onChange receives full client object or null.
 */
export default function ClientSelector({
  clients = [],
  value,
  onChange,
  label = 'Select Client',
  size = 'small',
  minWidth = 200,
  allowEmpty = false,
  emptyLabel = 'Select a client',
  fullWidth = false,
  disabled = false,
  sx,
}) {
  const list = Array.isArray(clients) ? clients : [];

  const handleChange = (event) => {
    const raw = event.target.value;
    if (raw === '' || raw == null) {
      onChange?.(null);
      return;
    }
    const client = list.find((c) => c.id === raw || String(c.id) === String(raw));
    onChange?.(client ?? null);
  };

  return (
    <FormControl
      size={size}
      sx={{ minWidth: fullWidth ? undefined : minWidth, ...sx }}
      fullWidth={fullWidth}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value ?? ''}
        label={label}
        onChange={handleChange}
        displayEmpty={allowEmpty}
      >
        {allowEmpty ? (
          <MenuItem value="">
            <em>{emptyLabel}</em>
          </MenuItem>
        ) : null}
        {list.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {client.name || `Client ${client.id}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
